module.exports = __webpack_public_path__ + "static/img/doctor.4a9f185.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/doctor.jpeg
// module id = RCQD
// module chunks = 0